<p>vendor-trans-details works!</p>
